import React__default, { useContext, useState } from 'react';
import { ThemeContext } from '../provider.js';
import classNames from './../external_lib/classnames/index.js';
import Typography from '../Atoms/Typography.js';
import DownOutlined from './../external_lib/@ant-design/icons/DownOutlined.js';
import Dialog from './Dialog.js';

var CountryHelper = {
    getCountryFlag: function (countryList, countryCode) {
        var country = countryList.find(function (country) { return country.dial_code === countryCode; });
        return "https://flagcdn.com/40x30/".concat(country === null || country === void 0 ? void 0 : country.code.toLowerCase().substring(0, 2), ".webp");
    }
};
function CountryFlagComponent(_a) {
    var classes = _a.classes, onCountryChange = _a.onCountryChange, _b = _a.countryCode, initialCountryCode = _b === void 0 ? '+91' : _b, disabled = _a.disabled, _c = _a.countryCodes, countryCodes = _c === void 0 ? [{ code: 'INR', dial_code: '+91' }] : _c, _d = _a.noFlag, noFlag = _d === void 0 ? false : _d;
    var theme = useContext(ThemeContext).theme;
    var _e = useState(initialCountryCode ||
        (countryCodes === null || countryCodes === void 0 ? void 0 : countryCodes[0].dial_code) ||
        theme.countryCode ||
        '+91'), countryCode = _e[0], setCountryCode = _e[1];
    var _f = useState(false), _isOpen = _f[0], setIsOpen = _f[1];
    var handleOnCountryChange = function (countryCode) {
        setCountryCode(countryCode);
        setIsOpen(false);
        onCountryChange && onCountryChange(countryCode);
    };
    var handleOpenCountryDialog = function () {
        if (disabled || countryCodes.length < 2)
            return;
        setIsOpen(true);
    };
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("div", { onClick: handleOpenCountryDialog, className: classNames('country-flag-component', classes) },
            !noFlag && (React__default.createElement("img", { className: "country-flag-component__flag", src: CountryHelper.getCountryFlag(countryCodes, countryCode), alt: countryCode.toUpperCase().substring(0, 2) })),
            React__default.createElement(Typography, { variant: "bodyTextOneMain" }, countryCode),
            countryCodes.length > 1 && (React__default.createElement(DownOutlined, { className: "country-flag-component__down-icon" }))),
        countryCodes.length > 1 && (React__default.createElement(Dialog, { classes: "country-flags__dialog", removeCloseIcon: true, onClose: function () { return setIsOpen(false); }, isOpen: _isOpen, footer: null, uniqueKey: "country-flags" }, countryCodes.map(function (country) { return (React__default.createElement("div", { onClick: function () { return handleOnCountryChange(country.dial_code); }, className: "country-flags__dialog__row" },
            React__default.createElement("div", { className: "country-flags__dialog__left" },
                !noFlag && (React__default.createElement("img", { className: "country-flags__dialog__left-flag", src: CountryHelper.getCountryFlag(countryCodes, country.code), alt: countryCode })),
                React__default.createElement(Typography, { variant: "bodyTextOneMain" }, country.code.toUpperCase().substring(0, 2))),
            React__default.createElement(Typography, { variant: "bodyTextOneMain" }, country.dial_code))); })))));
}

export { CountryFlagComponent as default };
//# sourceMappingURL=CountryFlagComponent.js.map
